module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/will-vux-stop-maintaining-27.vue");


//////////////////
// WEBPACK FOOTER
// ./en/faq/will-vux-stop-maintaining.md
// module id = 604
// module chunks = 173